var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('barcode',{attrs:{"value":_vm.barcodeValue}},[_vm._v(" "+_vm._s(_vm.barcodeValue !== null ? _vm.barcodeValue : "codice non valido")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }